export class ServiceRequest {
  "Account Id": string = "";
  "CSN": string = "";
  "SR Number": string = "";
  "SR Type": string = "";
  "SR Sub Type": string = "";
  "Status": string = "";
  "Created By Name": string = "";
}

export class ListOfDCGetSRSummaryIO {
  "Service Request": ServiceRequest = new ServiceRequest();
}

export class IncomingHierarchy {
  MessageId: string = "";  // Should be generated dynamically
  IntObjectName: string = "DCGetSRSummaryIO";
  MessageType: string = "Integration Object";
  IntObjectFormat: string = "Siebel Hierarchical";
  ListOfDCGetSRSummaryIO: ListOfDCGetSRSummaryIO = new ListOfDCGetSRSummaryIO();
}

export class ApplicationRequestBody {
  ProcessName: string = "DC Get SR Summary Mob App WF";
  IncomingHierarchy: IncomingHierarchy = new IncomingHierarchy();
  Language: string = "ENU";
  PageSize: number = 10;
  StartRowNum: number = 0;
  NewQuery: boolean = true;
  NoDays: number = 15;
}

export class ApplicationRequest {
  body: ApplicationRequestBody = new ApplicationRequestBody();
}
